import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface ImageWrapperProps {
    width: string;
    height: string;
}

export const BillDetailsItemWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    margin: `${theme.spacing.small} 0`,
    gap: theme.spacing.medium,
}));

export const LogoTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const BillItemText = styled(Text)`
    font-weight: 500;
`;
export const RightTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xSmall,
}));

export const StrikedText = styled(Text)(() => ({
    textDecoration: "line-through",
}));

export const LeftSubTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxxSmall,
}));

export const StyledText = styled(Text)`
    em {
        font-size: smaller;
        font-weight: 200;
        color: #9b9b9b;
    }
`;

export const ImageWrapper = styled.div<ImageWrapperProps>(({ width, height }) => ({
    display: "flex",
    alignItem: "center",
    justifyContent: "center",
    height: height,
    width: width,
}));
